module.exports = __webpack_public_path__ + "img/sld_annunciator.40bf2514.svg";